import { render } from "./Search.vue?vue&type=template&id=fe80d256&scoped=true&ts=true"
import script from "./Search.vue?vue&type=script&lang=ts"
export * from "./Search.vue?vue&type=script&lang=ts"

import "../assets/scss/search.scss?vue&type=style&index=0&id=fe80d256&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe80d256"]])

export default __exports__